import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faLock,
  faImage,
  faBell,
  faCreditCard,
  faDice,
  faUserPlus,
  faStar,
  faDoorOpen
} from '@fortawesome/free-solid-svg-icons';
import { authAPI } from '../services/api';
import Footer from './Footer';
import './Settings.css';

function Settings() {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { path: '/settings/personal', label: 'Personal Details', icon: faUser },
    { path: '/settings/security', label: 'Security Details', icon: faLock },
    { path: '/settings/profile-image', label: 'Profile Image', icon: faImage },
    { path: '/settings/notifications', label: 'Notification Settings', icon: faBell },
    { path: '/settings/subscriptions', label: 'Manage Subscriptions', icon: faCreditCard },
    { path: '/settings/bookie-accounts', label: 'Bookie Accounts', icon: faDice },
    { path: '/settings/refer', label: 'Refer Your Mates', icon: faUserPlus },
    { path: '/settings/start-club', label: 'Start a Club', icon: faStar },
    { path: '/settings/leave-club', label: 'Leave a Club', icon: faDoorOpen },
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    authAPI.logout();
    navigate('/login');
  };

  return (
    <div className="settings-wrapper">
      <header className="settings-app-header">
        <div className="header-container">
          <div className="header-logo">
            <img src="/logo.png" alt="Punt Club" />
            <h1>Punt Club</h1>
          </div>
          <div className="header-user">
            <Link to="/dashboard" className="back-link">
              ← Dashboard
            </Link>
            <button onClick={handleLogout} className="btn-logout">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="settings-container">
        <div className="settings-header">
          <h2>Settings</h2>
        </div>

        <div className="settings-content">
          <nav className="settings-menu">
            <ul>
              {menuItems.map((item) => (
                <li key={item.path} className={isActive(item.path) ? 'active' : ''}>
                  <Link to={item.path}>
                    <span className="menu-icon">
                      <FontAwesomeIcon icon={item.icon} />
                    </span>
                    <span className="menu-label">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="settings-page">
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Settings;
